module.exports = __webpack_public_path__ + "static/media/allie24.e8aaeb57.jpg";